/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserQrCodeLegacy {
  /**
   * User QR code regex (readonly)
   */
  code_regex?: string;
  /**
   * Current version of user QR code (readonly)
   */
  version?: number | null;
}
